<template>
  <div class="wrap mt61">
    <el-carousel height="29.16vw" arrow="never">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <img
          :src="item.imageUrl"
          alt=""
          style="width:100%;height:29.16vw;cursor:pointer;"
          @click="gotoCourseOidDetail(item)"
        />
      </el-carousel-item>
    </el-carousel>
    <div class="teach-tool" :style="{backgroundImage: 'url(' + dotBgi + ')'}">
        <div class="teach-wrap">
          <div class="teach-top">
            <img :src="teachToolIcon" alt="" class="teacher-t-img">
          </div>
          <div class="teacher-dotLine">
            <img :src="dotLine"/>
          </div>
          <div class="teacher-bottom">
            <div class="teacher-bottom-l">
              <div class="teacher-b-l-tit">
                <p class="teacher-b-l-tit-big">安预在线</p>
                <p class="teacher-b-l-tit-little">平台四大教学工具让培训更简单</p>
              </div>
              <div class="teacher-b-l-con">
                <div class="teacher-b-l-c-t" style="display:flex">
                  <div class="teacher-b-l-c-t-l">
                    <p><img class="star01" :src="star01Icon"/><span class="teacher-b-l-con-tit">课程管理</span></p>
                    <ul style="margin-top: 6px">
                      <li>录播课</li>
                      <li>音频课</li>
                      <li>图文课</li>
                      <li>文档</li>
                    </ul>
                  </div>
                  <div class="teacher-b-l-c-t-r" style="margin-left: 142px">
                    <p><img class="star01" :src="star01Icon"/><span class="teacher-b-l-con-tit">考试管理</span></p>
                    <ul style="margin-top: 6px">
                      <li>多种题型</li>
                      <li>自定义计时</li>
                      <li>一课一练</li>
                      <li>自定义组卷</li>
                    </ul>
                  </div>
                </div>
                <div class="teacher-b-l-c-b" style="display:flex;margin-top: 46px">
                  <div class="teacher-b-l-c-b-l">
                    <p><img class="star01" :src="star01Icon"/><span class="teacher-b-l-con-tit">调研管理</span></p>
                    <ul style="margin-top: 6px">
                      <li>多种形式</li>
                      <li>多种模板</li>
                      <li>可视化图表</li>
                    </ul>
                  </div>
                  <div class="teacher-b-l-c-b-r" style="margin-left: 142px">
                    <p><img class="star01" :src="star01Icon"/><span class="teacher-b-l-con-tit">数据统计</span></p>
                    <ul style="margin-top: 6px">
                      <li>用户统计</li>
                      <li>资源统计</li>
                      <li>活跃统计</li>
                      <li>任务统计</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="teacher-bottom-r">
              <img :src="p01Icon"/>
            </div>
          </div>
        </div>
    </div>
    <div class="multiport-S">
      <div class="mutiport-wrap">
        <div class="muti-top">
          <img :src="multititle" alt="" class="muti-t-img">
        </div>
        <div class="muti-down">
          <img src="/static/index/leftArrow.png" alt="" class="arrrow" @click="prevCilck()">
          <div style="width:100%;padding-left:53px;">
            <el-carousel height="732px" :autoplay="false" indicator-position='none' arrow='never' ref="mutiImg">
              <el-carousel-item v-for="(item,index) in mutiportList" :key="index" >
                <div style="display:flex;">
                   <img :src="item.imgUrl" :class="index == 0 ? 'muti-d-img0': index == 1 ||index == 3 ? 'muti-d-img1' : 'muti-d-img2'" >
                  <div :class="'muti-d-r muti-d-rindex'+index">
                    <div :class="'muti-d-r-w muti-d-r-windex'+index">
                      <div style="font-size:36px;margin-bottom:71px;">{{item.name}}</div>
                      <div style="font-size:26px;text-align:left;
line-height: 48px;" v-if="index == 0">
                        <div>支持安卓端和苹果端双系统使用</div>
                        <div>利用碎片化时间随时进行学习</div>
                        <div>满足了个性化的学习需求</div>
                        <div>以独立的应用程序运行</div>
                        <div>节省带宽成本</div>
                      </div>
                      <!--  -->
                       <div style="font-size:26px;text-align:left;
line-height: 48px;" v-if="index == 1">
                        <div>嵌于微信内部,便于搜索</div>
                        <div>轻便随时使用,用户体验极佳</div>
                        <div>不占内存、无需下载、耗流低</div>
                      </div>
                      <!--  -->
                       <div style="font-size:26px;text-align:left;
line-height: 48px;width: 238px;" v-if="index == 2">
                        <div>兼容性强</div>
                        <div>满足多种用户需求</div>
                        <div>多端学习,进度同步</div>
                      </div>
                      <!--  -->
                       <div style="font-size:26px;text-align:left;
line-height: 48px;" v-if="index == 3">
                        <div>无需下载,使用微信扫码打开或点击链接打开即可进行学习</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <img src="/static/index/rightArrow.png" alt="" class="arrrow" @click="nextCilck()">
        </div>
      </div>
    </div>
    <!--  -->
    <div class="educational-tool">
      <div class="edu-wrap">
          <div class="edu-wrap-t">
            <img :src="edutoolIcon" alt="" style="width:522px;height:52px;display:block;margin:0 auto;padding-top:68px;">
          </div>
          <div class="edu-wrap-d">
              <div v-for='(item,index) in educationalList' :key="index" style="width:25%;">
                <img :class="'mt0a edu-d-img'+index" :src="item.imgUrl" alt="">
                <div style="font-size:26px;color:#515151; margin-top:42px;text-align:center;">{{item.name}}</div>
              </div>
          </div>
      </div>
    </div>
    <!--  -->
    <div class="serve-tool">
      <div style="width:1450px;margin:0 auto;">
          <div class="edu-wrap-t">
              <img :src="serveIcon" alt="" style="width:205px;height:52px;display:block;margin:0 auto;padding-top:68px;">
          </div>
         <div class="serve-t-d">
           <div class="serve-t-d-c">
              <div style="height:252px;border-left: 2px dotted #D5DDFF;width:1px;position: absolute;top: 44px;left: -3px;"></div>
             <div v-for="(item,index) in serveList" :key="index" class="serve-t-d-c-w">
               <div :class="index ==serveIndex ?' serve-t-d-c-a serve-is-active': 'serve-t-d-c-a'" >
                 <div class="serve-t-d-c-q"></div>
                 <div style="margin-left:61px;">0{{index+1}}</div>
                 <div style="margin-left:48px;width: 455px;">{{item.content}}</div>
               </div>
             </div>
           </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import P01Icon from "@/assets/01.png"
import P02Icon from "@/assets/02.png"
import P03Icon from "@/assets/03.png"
import P04Icon from "@/assets/04.png"
import P05Icon from "@/assets/05.png"
import Multititle from "@/assets/multititle.png"
import EdutoolIcon from "@/assets/edutool.png"
import T01Icon from "@/assets/t01.png"
import DotLine from "@/assets/dotLine.png"
import DotBgi from "@/assets/dotBgi.png"
import ServeIcon from "@/assets/serve.png"
import Star01Icon from "@/assets/star01.png"
import TeachToolIcon from "@/assets/teachtool.png"
import QueIcon from "@/assets/que.png"
export default {
  name: "Main",
  data() {
    return {
      star01Icon: Star01Icon,
      t01Icon: T01Icon,
      dotLine: DotLine,
      dotBgi: DotBgi,
      multititle: Multititle,
      edutoolIcon: EdutoolIcon,
      p01Icon: P01Icon,
      p02Icon: P02Icon,
      p03Icon: P03Icon,
      p04Icon: P04Icon,
      p05Icon: P05Icon,
      serveIcon: ServeIcon,
      teachToolIcon: TeachToolIcon,
      queIcon: QueIcon,
      bannerList: [
        {
          imageUrl:'/static/index/banner.png'
        }
      ],
      mutiportList:[
       {
        imgUrl: P02Icon,
        name:'安预在线APP',
        content:'支持安卓端和苹果端双系统使用,利用碎片化时间随时进行学习,满足了个性化的学习需求,以独立的应用程序运行,节省带宽成本'
       },
       {
        imgUrl: P03Icon,
        name:'安预在线小程序',
        content:'嵌于微信内部，便于搜索,轻便随时使用，用户体验极佳,不占内存、无需下载、耗流低'
       },
       {
        imgUrl: P05Icon,
        name:'安预在线PC学习端',
        content:'兼容性强,满足多种用户需求,多端学习，进度同步'
       },
       {
        imgUrl: P04Icon,
        name:'安预在线H5',
        content:'无需下载，使用微信扫码打开或点击链接打开即可进行学习'
       }
      ],
      educationalList:[
        {
          imgUrl:'/static/index/educational1.png',
          name:'录播课程防挂课'
        },
        {
          imgUrl:'/static/index/educational2.png',
          name:'登录人脸核审验证'
        },
        {
           imgUrl:'/static/index/educational3.png',
          name:'人脸识别进入课程'
        },
        {
           imgUrl:'/static/index/educational4.png',
          name:'在线二维码打卡'
        },
        {
           imgUrl:'/static/index/educational5.png',
          name:'岗位分配课程'
        },
        {
           imgUrl:'/static/index/educational6.png',
          name:'考试组卷自定义'
        },
        {
           imgUrl: QueIcon,
          name:'调查问卷'
        },
        {
           imgUrl:'/static/index/educational8.png',
          name:'电子证书'
        }
      ],
      serveList:[
        {
          content:'7×24小时客服在线服务，保障突发事情得应急措施'
        },
        {
          content:'资深技术团队，提供强大的后台支撑保障'},
        {
          content:'监管持续更新，保证功能可持续性的更新迭代。'},
        {
          content:'实时监控系统安全，以保护用户、课件、系统安全。'
        }
      ],
      serveIndex:0
    };
  },
  created: function() {
    this.getBannerList();
    this.setServe()
  },
  watch:{
    serveIndex:{
       handler() {
        this.setServe()
      }
     
    }
  },
  methods: {
    setServe(){
      setTimeout(()=>{
        if(this.serveIndex ==3){
            this.serveIndex=0
        }else[
            this.serveIndex++
        ]
      }, 1600);
    },
    getBannerList() {
      // this.$axios
      //   .get(address.bannerIndex, {
      //     params: {}
      //   })
      //   .then(res => {
      //     this.bannerList = res.data.data;
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
    },
    prevCilck(){
      this.$refs.mutiImg.prev();
    },
    nextCilck(){
      this.$refs.mutiImg.next();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrap {
  /* position: absolute;
  top: 0; */
  width: 100%;
}
.teach-tool{
  width: 100%;
  height: 827px;
  /* background-image: url('/static/index/teachingTool.png'); */
  background-repeat: repeat;
}
.multiport-S{
  width: 100%;
  height: 842px;
  background-image: url('/static/index/multiportS.png');
  background-size: 100% 100%;
}
.mutiport-wrap{
  width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}
.teacher-top, .muti-top{
  width:100%;
}
.muti-t-img{
  width:239px;
  height: 52px;
  margin: 0 auto;
  padding-top: 47px;
  display: block;
}
.muti-down{
  width:100%;
  display: flex;
  position: relative;
  align-items: center;
}
.arrrow{
  width: 38px;
  height: 64px;
  cursor: pointer;
}
.muti-d-img0{
 width:353px;
 height:661px;
}
.muti-d-img1{
  width:488px;
  height:686px;
}
.muti-d-img2{
  width:564px;
  height:493px;
  margin-top:122px;
}
.muti-d-rindex1{
  margin-left: 73px !important;
}
.muti-d-rindex2{
  margin-left: 20px !important;
}
.muti-d-rindex3{
  margin-left: 73px !important;
}
.muti-d-r-windex2{
  width: 420px  !important;
}
.muti-d-r{
  width:442px;
  color: #48659C;
  text-align: center;
  display: flex;
  align-items: center;
  margin-left:142px;
}
.muti-d-r-w{
  display: flex;
  flex-direction:column;
  align-items: center;
}
.educational-tool{
  width: 100%;
  height: 633px;
  background-image: url('/static/index/help-S.png');
  background-size: 100% 100%;
}
.edu-wrap{
  width: 1200px;
  margin: 0 auto;
}
.edu-wrap-d{
  width:100%;
  display: flex;
  flex-wrap: wrap;
  margin-top:41px;
  cursor: pointer;
}
.edu-d-img0{
  width: 77px;
  height: 58px;
}
.edu-d-img1{
  width: 72px;
  height: 59px;
}
.edu-d-img2{
  width: 59px;
  height: 58px;
}
.edu-d-img3{
  width: 52px;
  height: 64px;
}
.edu-d-img4{
  width: 58px;
  height: 66px;
  margin-top:110px  !important;
}
.edu-d-img5{
  width: 64px;
  height: 67px;
  margin-top:110px  !important;
}
.edu-d-img6{
  width: 58px;
  height: 66px;
  margin-top:110px !important;
}
.edu-d-img7{
  width: 56px;
  height: 68px;
  margin-top:110px  !important;
}
.mt0a{
  margin:0 auto;
  display: block;
}
.serve-tool{
  width: 100%;
  height: 876px;
  background-image: url('/static/index/server-s.png');
  background-size: 100% 100%;
}
.serve-t-d{
  width: 100%;
  height: 658px;
  background-image: url('/static/index/server-d.png');
  background-size: 100% 100%;
  position: relative;
}
.serve-t-d-c{
  position:absolute;
  left:20%;
  top:22%;
}
.serve-t-d-c-a{
  display:flex;
  line-height: 48px;
  cursor: pointer;
  font-size: 26px;
  /* align-items: center; */
  color: #504E65;
  /* border-left: 2px dotted #D5DDFF; */
}

.serve-t-d-c-q{
  width: 20px;
  height: 20px;
  line-height: 48px;
  border: 2px solid #D5DDFF;
  background:#fff;
  /* background: linear-gradient(0deg, #4162FF 0%, #5F7EFF 100%); */
  border-radius: 50%;
  margin-right:21px;
  position: absolute;
  left: -14px;
  margin-top:12px;
}
/* .serve-t-d-c-a:hover{
  color: #5978FF;
}
.serve-t-d-c-a:hover .serve-t-d-c-q{
  background: linear-gradient(0deg, #4162FF 0%, #5F7EFF 100%); 
} */
.serve-is-active{
  color: #5978FF !important;
}
.serve-is-active .serve-t-d-c-q{
 background: linear-gradient(0deg, #4162FF 0%, #5F7EFF 100%) !important;
}
.color51 {
  color: #5151ff;
}
.colorfff {
  color: #fff;
}


/* .courseContent:first-child {
  margin-left: 0;
}
.courseContent:last-child {
  margin-right: 0;
} */
.el-tabs__item {
  height: 90px !important;
}
.liveStreaming-wrap
  .el-tabs--right
  .el-tabs--right
  .el-tabs__header.is-right
  .el-tabs--right.el-tabs__nav-wrap.is-right
  .el-tabs__nav-scroll
  .el-tabs__nav
  .el-tabs__item
  .el-tabs__item.is-right {
  height: 66px !important;
  line-height: 66px !important;
}
/deep/ .el-tabs__item.is-right {
  height: 70px !important;
  line-height: 70px !important;
}
/deep/ .el-tabs--right .el-tabs__active-bar.is-right {
  widows: 4px;
}
/deep/ .el-tabs__active-bar {
  background-color: #3f61ff;
}
/deep/ .el-tabs__item.is-active {
  color: #3f61ff;
}
/deep/ .el-tabs--right .el-tabs__header.is-right {
  width: 502px;
}
/deep/ .el-tabs__item:hover {
  color: #3f61ff;
}
/deep/ .el-carousel__container {
  width: 100%;
}
.wrap .el-carousel .el-carousel__container .el-carousel__indicators .el-carousel__indicator .el-carousel__buttom {
  height: 8px !important;
  border-radius: 4px !important;
}
</style>

<style scoped>
.teach-tool {
  display: flex;
  justify-content: center;
}
.teach-wrap {
  /* width: 1200px; */
}
.teacher-t-img {
  width: 396px;
  height: auto;
  margin: 0 auto;
  padding-top: 47px;
  display: block;
}
.teacher-dotLine {
  margin-top: 47px;
}
.teacher-dotLine img {
  margin-left: 205px;
}
.teacher-bottom {
  display: flex;
  justify-content: center;
  margin-top: 5px;
  color: #48659C;
}
.teacher-bottom-l {
  /* width: 355px; */
}
.teacher-bottom-r {

}
.teacher-bottom-r img {
  width: 714px;
  height: auto;
  margin-left: 131px;
}
.teacher-b-l-tit {
  text-align: center;
}
.teacher-b-l-tit-big {
  font-size: 36px;
  font-weight: bold;
  color: #4163FF;
  line-height: 52px;
}
.teacher-b-l-tit-little {
  font-size: 16px;
  color: #9298B0;
  line-height: 26px;
  margin-top: 5px;
}
.teacher-b-l-con {
  margin-top: 37px;
}
.teacher-b-l-con-tit {
  font-size: 26px;
  margin-left: 17px;
}
.teacher-b-l-con li {
  list-style: none;
  text-align: right ;
  font-size: 18px;
  line-height: 1.61;
}
.star01 {
  display: inline-block;
  width: 16px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/Main.vue